import { PanelRow, ToggleControl, FormTokenField, Dropdown, Button, RangeControl } from '@wordpress/components'
import { dispatch, useSelect } from '@wordpress/data'
import { useState, useEffect } from '@wordpress/element';

import { __ } from '@wordpress/i18n'

export default ({dates, _dateIndex, _date, onUpdate, storeKey}) => {

    const [{enableTime,stateHours, stateMinutes},setState] = useState({
        // @since 6.1.0 comment
        // enableTime:[],
        stateHours:0,
        stateMinutes:0
    });
    const updateDatesTimes = (data, _dateIndex) => {

        let _allDates = dates;
        _allDates[_dateIndex] = {..._allDates[_dateIndex], ...data }

        onUpdate(storeKey, _allDates );
    }

    const { twentyfour_time_format, enable_time } = _date;
    let selectedTimes = 'undefined'!==typeof _date.trip_time && '' !== _date.trip_time?_date.trip_time.split(','): [];
    return <>
        <PanelRow>
            <label>{ __( 'Enable Time', 'wp-travel-pro' ) }</label>
            <ToggleControl
            checked={enable_time}
            onChange={ () => {

                updateDatesTimes( { enable_time: ! enable_time }, _dateIndex );
            } }
        />
        
        </PanelRow>
       
            { enable_time&&<> <PanelRow>
            <label>{ __( 'Enable 24 Hours Time Format', 'wp-travel-pro' ) }</label>
            <ToggleControl
            checked={twentyfour_time_format}
            onChange={ () => {
                updateDatesTimes( { twentyfour_time_format: ! twentyfour_time_format }, _dateIndex );
            } }
        />
        
        </PanelRow><PanelRow>
                <label>{ __( 'Select Time', 'wp-travel-pro' ) }</label>
                <div className="text-right">
                    <FormTokenField 
                        label=""
                        value={ selectedTimes } 
                        suggestions={ [] } 
                        onChange={ tokens =>{
                            let _tokens = tokens.filter((token)=>{
                                return token.match(/^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/gm);
                            })

                            updateDatesTimes( { trip_time: _tokens.join(',') }, _dateIndex );
                        }}
                    />

                    <Dropdown
                        className="my-container-class-name"
                        contentClassName="my-popover-content-classname"
                        position="bottom right"
                        renderToggle={ ( { isOpen, onToggle } ) => (
                            <Button onClick={ onToggle } aria-expanded={ isOpen } isLink>{ __( '+ Add Time', 'wp-travel-pro' ) }</Button>
                        ) }
                        renderContent={ ({ isOpen, onToggle } ) => (
                            <div className="wp-travel-dropdown-content-wrap">
                            <div>
                                    <label>{ __( 'Hours', 'wp-travel-pro' ) }</label>
                                    <RangeControl
                                        // label="Hours"
                                        value={ stateHours ? stateHours : 0 }
                                        onChange={ ( hours ) => {
                                            // hours = hours < 10 ? '0'+hours:hours;
                                            setState( (prevState)=>{
                                                return { ...prevState, stateHours:hours }
                                            } )
                                        }}
                                        min={ 0 }
                                        max={ 23 }
                                    />
                            </div>
                            <div>
                                    <label>{ __( 'Minute', 'wp-travel-pro' ) }</label>
                                    <RangeControl
                                        // label="Hours"
                                        value={ stateMinutes ? stateMinutes : 0 }
                                        onChange={ ( minutes ) => {
                                            // hours = hours < 10 ? '0'+hours:hours;
                                            setState( (prevState)=>{
                                                return { ...prevState, stateMinutes:minutes }
                                            } )
                                        }}
                                        min={ 0 }
                                        max={ 59 }
                                    />
                            </div>
                            <div className="wp-travel-add-time">
                                <Button onClick={()=>{
                                    
                                    let _minutes = stateMinutes ? stateMinutes < 10 ? '0'+stateMinutes:stateMinutes : '00';
                                    let _hours = stateHours ? stateHours < 10 ? '0'+stateHours:stateHours : '00';
                                    let time = `${_hours}:${_minutes}`;
                                    
                                    if ( time.match(/^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/gm) && !selectedTimes.includes(time) ){
                                        let newSelectedTimes = [...selectedTimes,time];
                                        newSelectedTimes.sort((ls,rs)=>{
                                            if( ls < rs ) return -1;
                                            if( ls > rs ) return 1;
                                            return 0;
                                        })
                                        
                                        updateDatesTimes( { trip_time: newSelectedTimes.join(',') }, _dateIndex );
                                    }
                                    onToggle()
                                }} isDefault>{ __( '+ Add', 'wp-travel-pro' ) }</Button>

                            </div>
                            </div>
                        ) }
                    />
                </div>
                
            </PanelRow>
        </>}
    </>
}